var _defs, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Typescript_logo_2020",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3178c6;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6894",
    "data-name": "Rectangle 6894",
    className: "cls-1",
    width: 111,
    height: 111,
    rx: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6895",
    "data-name": "Rectangle 6895",
    className: "cls-1",
    width: 111,
    height: 111,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    className: "cls-2",
    d: "M160.961,274.587V285.4a22.91,22.91,0,0,0,6.236,2.027,41.076,41.076,0,0,0,7.587.676,35.457,35.457,0,0,0,7.385-.743,18.1,18.1,0,0,0,6.134-2.449,12.48,12.48,0,0,0,4.174-4.459,15.71,15.71,0,0,0,.659-11.959,12.04,12.04,0,0,0-2.535-3.936,18.559,18.559,0,0,0-3.971-3.091,42.536,42.536,0,0,0-5.222-2.584q-2.129-.878-3.819-1.706a19.394,19.394,0,0,1-2.873-1.689,7.365,7.365,0,0,1-1.825-1.824,3.839,3.839,0,0,1-.642-2.179,3.642,3.642,0,0,1,.575-2.01,4.961,4.961,0,0,1,1.622-1.537,8.676,8.676,0,0,1,2.569-1,14.9,14.9,0,0,1,3.38-.355,21.443,21.443,0,0,1,2.856.2,22.6,22.6,0,0,1,3.025.625,21.059,21.059,0,0,1,2.957,1.064,16.3,16.3,0,0,1,2.653,1.487v-10.1a26.394,26.394,0,0,0-5.391-1.4,43.925,43.925,0,0,0-6.709-.456,31.186,31.186,0,0,0-7.3.828,18.571,18.571,0,0,0-6.067,2.584,12.914,12.914,0,0,0-4.14,4.476,13.124,13.124,0,0,0-1.521,6.5,12.609,12.609,0,0,0,2.788,8.243,21.217,21.217,0,0,0,8.466,5.777q2.231.912,4.157,1.79a23.135,23.135,0,0,1,3.329,1.824,8.729,8.729,0,0,1,2.214,2.061,4.2,4.2,0,0,1,.811,2.534,3.876,3.876,0,0,1-.507,1.942,4.5,4.5,0,0,1-1.538,1.554,8.43,8.43,0,0,1-2.569,1.03,15.436,15.436,0,0,1-3.6.372,20.539,20.539,0,0,1-6.962-1.233,20.777,20.777,0,0,1-6.388-3.7Zm-18.174-26.636h13.868V239.08H118v8.872h13.8v39.5h10.986Z",
    transform: "translate(-92.518 -186.604)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.0d1492e765ee73a3bba1d960f4c5aa32.svg";
export { ForwardRef as ReactComponent };